import { unauthedApiClient } from "../../util/UnauthedApiClient";
import { UNAUTHED_SUBMITTER_PATH } from "../../config/Api";

export const SUBMITTER_LOAD_STARTED = "SUBMITTER_LOAD_STARTED";
export const SUBMITTER_LOAD_FINISHED = "SUBMITTER_LOAD_FINISHED";
export const SUBMITTER_LOAD_ERRORED = "SUBMITTER_LOAD_ERRORED";

export const submitterLoadStarted = () => {
  return {
    type: SUBMITTER_LOAD_STARTED
  };
};

export const submitterLoaded = submitter => {
  return {
    type: SUBMITTER_LOAD_FINISHED,
    payload: submitter
  };
};

export const submitterLoadErrored = error => {
  return {
    type: SUBMITTER_LOAD_ERRORED,
    payload: error
  };
};

const submitterInitialState = {
  loading: false,
  unloaded: true,
  error: false
};

export const submitterReducer = (state = submitterInitialState, action) => {
  switch (action.type) {
    case SUBMITTER_LOAD_STARTED:
      return {
        loading: true
      };
    case SUBMITTER_LOAD_FINISHED:
      return action.payload;
    case SUBMITTER_LOAD_ERRORED:
      return {
        error: action.payload
      };
    default:
      return state;
  }
};

export const loadSubmitter = (uuid, modifyKey) => {
  return dispatch => {
    dispatch(submitterLoadStarted());

    unauthedApiClient(modifyKey)
      .get(UNAUTHED_SUBMITTER_PATH(uuid))
      .then(response => {
        dispatch(submitterLoaded(response.data));
      })
      .catch(error => {
        dispatch(submitterLoadErrored(error));
      });
  };
};

// Not an action
export const saveSubmitter = (uuid, modifyKey) => {
  return submitterData => {
    return unauthedApiClient(modifyKey)
      .post(UNAUTHED_SUBMITTER_PATH(uuid), submitterData)
      .then(response => {
        return response.data;
      });
  };
};

export const isSubmitterLoading = state =>
  state.unauthenticated.submitter.unloaded ||
  state.unauthenticated.submitter.loading;
export const getSubmitterError = state => state.unauthenticated.submitter.error;



// WEBPACK FOOTER //
// ./frontend/src/actions/unauthenticated/submitter.js